import React, { useEffect, useState } from "react";
import { Page, SubmitButton, required, FormGroup, DatePicker } from "components/common";
import { Control, actions, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm, useModal } from "hooks";
import Select from "react-select";
import { Trans } from "react-i18next";
import { Col, Row, Table, Button, Badge, UncontrolledCollapse, Label, Input } from "reactstrap";
import BackButton from "components/refactoring/BackButton";
import { useBaseModal } from "services";
import { formatDate } from "services/util";
import { useForm as RenewForm } from "react-hook-form";
import InputFile from "components/common/InputFile";
import { HistoryAndNotes } from "components";


export const ContractEdit = ({ payroll, t, url = "contracts", model = "local", history, match, client }) => {
  const { id } = match.params;
  const { dispatch, setValue, Form, save, loaded, load, getTitle, value } =
    useForm({
      model,
    });

  const [employees, setEmployees] = useState([]);
  const [reload, setReload] = useState(false);
  const [contract_options, setContract_options] = useState(false);

  let status_color = ""

  const { Modal, setIsOpen, isOpen, toggle, ModalHeader, ModalBody, ModalFooter } = useModal();
  const [SetRenewModal, RenewToggle, RenewModal]  = useBaseModal();
  const { register, handleSubmit, getValues, setValue: setRenewValue, watch } = RenewForm();
  const attachmentWatch = watch("attachment", "")
  const [final_contract, setFinal_contract] = useState(value.final_contract || false);


  React.useEffect(() => {
    register("attachment");
  }, [register]);

  useEffect(() => {
    let params = ""
    if (id === "new") {
      params = "?new=true"
    }
    async function fetchData() {
      const [item, employees] = await Promise.all([
        load(payroll, url, id, {
          employee: null,
          status: "pending_approval",
        }),
        payroll
          .get(`contracts/employees${params}`)
          .get("data")
          .map((x) => ({
            label: x.full_name,
            value: x.id,
          }))
      ]);

      let contract_options = [];
      if (id !== "new") {
        contract_options = await payroll
          .get(`contracts/${id}/contract_options`)
          .get("data")
          .get('options')
          .map((x) => ({
            value: x[0],
            label: x[1],
          }))
      }

      setContract_options(contract_options);
      setEmployees(id == 'new' ? employees : [{ label: item.employee__full_name, value: item.employee }]);
      setValue({...item, read_only: id!=='new' && item.status !== 'pending_approval'});

    }
    fetchData();
  }, [reload, id]);

  if (value) {
    if (value.status === 'pending_approval') { status_color = "secondary"; }
    else if (value.status === 'ended' || value.status === 'pending_ending') { status_color = "warning"; }
    else if (value.status === 'active') { status_color = "primary"; }
  }



  const HandleEnd = async (item) => {
    item = { ...item, 'status': 'ended', 'final_contract': final_contract }
    try {
      const resp = await save(payroll, url, item);
      setIsOpen(false)
      NotificationManager.success(t("Ended successfully"));
      id === "new" ? history.push(`/payroll-new/contracts/${resp.data.id}`) : setReload(!reload)
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }

  const HandleReject = async (item) => {
    item = { ...item, 'status': 'active' }
    onSubmit(item)
  }
  const HandleRenew = async (data) => {
    data = { ...data, contract: parseInt(id) }
    payroll.post(`contract_renew`, data).then((resp) => {
      RenewToggle()
      NotificationManager.success(t("Renewed successfully"));
      id === "new" ? history.push(`/payroll-new/contracts/${resp.data.id}`) : setReload(!reload)
    }).catch((e) => {
      NotificationManager.success(t("Renewing Error"));
      console.log(e)
    })
  }


  async function onSubmit(item) {
    try {
      const resp = await save(payroll, url, item);
      NotificationManager.success(t("Saved successfully"));
      id === "new" ? history.push(`/payroll-new/contracts/${resp.data.id}`) : setReload(!reload)
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }


  if (!loaded) return null;

  return (
    <Page title={getTitle(id, "Contract")}>
      <BackButton />
      {value &&
        <>
          {isOpen &&
            <Modal >
              <ModalHeader toggle={toggle}>
                <Trans>Terminate Contract</Trans>
              </ModalHeader>
              <ModalBody>
                <Form onSubmit={HandleEnd}>
                  <Row>
                    <Col >
                      <FormGroup className="pb-3" label="Type" model=".termination_type" addControlClass={false} isRequired>
                        <Control.text style={{ backgroundColor: '#F4F7FE' }}
                          model=".termination_type"
                          component={Select}
                          options={contract_options}
                          simpleValue
                          clearable={false}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup label="Reason" model=".termination_reason" className="pb-2 pt-2 " isRequired>
                        <Control.textarea rows="4" model=".termination_reason" updateOn="blur" style={{ backgroundColor: '#F4F7FE' }} className="border" required/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col >
                      <FormGroup className="pb-3 text-nowrap" label="Termination Date" model=".terminated_date">
                        <DatePicker type="date" className="form-control" model=".terminated_date" defaultValue={new Date().toJSON().slice(0, 10)}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="col-12">
                        <FormGroup check className="px-1">
                          <Input name="final_contract" type="checkbox" checked={final_contract} onChange={(e) => setFinal_contract(!final_contract)} />
                          <Label check htmlFor="final_contract"><Trans>End Service!</Trans></Label>
                        </FormGroup>
                      </div>
                      {final_contract &&
                        <div className="mb-2">
                          <span className="text-danger">
                            <Trans>The employee service will be ended if you check this</Trans>
                          </span>
                        </div>
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-self-end">
                      <FormGroup className="text-right">
                        <SubmitButton color="success" className="mr-0">
                          <Trans>Terminate</Trans>
                        </SubmitButton>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </ModalBody>
            </Modal>
          }
          <RenewModal title={t("Renew Contract")}>
            <div className="d-block">
              <form onSubmit={handleSubmit(HandleRenew)}>
                <Row>
                  <Col >
                    <FormGroup className="pb-3 text-nowrap" label="Extend Contract To *">
                      <input type="date" className="form-control" {...register("extend_to")} />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col >
                    <FormGroup className="pb-3 text-nowrap" label="Note">
                      <textarea className="form-control" {...register("notes")} />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup className="pb-2 pt-3">
                      <label htmlFor=""><Trans>Attachment</Trans></label>
                      <InputFile file={attachmentWatch || ""} setData={(data) => { setRenewValue('attachment', data) }} custom={true}></InputFile>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="align-self-end">
                    <FormGroup className="text-right">
                      <Button color="success" className="mr-0">
                        <Trans>Renew</Trans>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </form>
            </div>
          </RenewModal>
          <div className="border p-2 my-2">
            <div className="row justify-content-between align-items-center mb-3">
              <div className="col-8">
                {id !== "new" && value.status && (<h4 className="d-inline-block">
                  <Badge color={status_color} className="font-weight-bold py-2 mr-2"><span className="font-weight-normal"><Trans>Status</Trans></span> ({t(value.status_label)})</Badge>
                </h4>)}
              </div>
              <div className="col-4">
                <div className="row justify-content-end align-items-center px-3">
                  {id !== "new" && value.is_active && (
                    <>
                      <div className="col flex-grow-0 px-0">
                        <Button className="ml-1 mr-0 btn btn-danger" onClick={() => { setIsOpen(true) }}><Trans>End Contract</Trans></Button>
                      </div>
                    </>
                  )}
                  {
                    id !== "new" && value.status !== "ended" && value.status !== "pending_approval" &&
                    <div className="col flex-grow-0 px-0">
                      <Button className="ml-1 mr-0 btn btn-success" onClick={() => { SetRenewModal(true) }}><Trans>Renew Contract</Trans></Button>
                    </div>
                  }
                </div>
              </div>
            </div>
            <Row>
              <Col md="12">
                <Form
                  onSubmit={onSubmit}
                  validators={{
                    employee: { required },
                    start_date: { required },
                  }}
                >
                  <Row>

                    <Col>
                      <FormGroup className="pb-3" label="Employee *" model=".employee" addControlClass={false}>
                        <Control.text style={{ backgroundColor: '#F4F7FE' }}
                          model=".employee"
                          component={Select}
                          options={employees}
                          simpleValue
                          clearable={false}
                          disabled={id !== "new"}
                        />
                        <Errors
                          className="form-text small text-danger"
                          model=".employee"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="Start Date *" model=".start_date">
                        <DatePicker type="date" className="form-control" model=".start_date" disabled={value.read_only} required/>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="End Date" model=".end_date" >
                        <DatePicker type="date" className="form-control" model=".end_date" disabled={value.read_only && value.end_date}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label={t("Position") + " *"} model=".position">
                        <Control.text model=".position" placeholder={t("Accounting")} required />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label={t("Monthly Salary") + " *"} model=".salary" >
                        <Control.text model=".salary" placeholder="10,000" type="number" required/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup label="Note" model=".approval_note" className="pb-2 pt-2 ">
                        <Control.textarea rows="4" model=".approval_note" updateOn="blur" style={{ backgroundColor: '#F4F7FE' }} className="border" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="pb-2 pt-3">
                        <label htmlFor=""><Trans>Attachment</Trans></label>
                        <InputFile t={t} file={value.attachment || ""} setData={setValue}></InputFile>
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-end d-print-none my-3">
                    {
                      value.status === 'pending_ending' ?
                        <div>
                          <Button className="ml-1 mr-0 btn btn-danger" onClick={() => { HandleReject(value) }}><Trans>Reject</Trans></Button>
                          <Button className="ml-1 mr-0 btn btn-primary" onClick={() => { setIsOpen(true) }}><Trans>Accept</Trans></Button>
                        </div>
                        :
                        <SubmitButton disabled={value.status === "ended"}> <Trans>{match.params.id === "new" ? t("Create") : value.status === 'pending_approval' ? t("Confirm") : t("Update")}</Trans></SubmitButton>
                    }
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
          {value.status === "ended" &&
            <div className="row-termination border p-3">
              <label className="d-block alert-warning"><Trans>This contract has ended for the following reason</Trans> : <span className="font-weight-bold"><Trans>{contract_options[value.termination_type > 7 ? value.termination_type - 8 : value.termination_type]?.label}</Trans></span></label>
              <p><Trans>More Details: </Trans><Trans>{value.termination_reason}</Trans></p>
            </div>}

          {(value.contract_ending_requests?.length > 0 || value.contract_renewals?.length > 0) &&
            <div className="contract-history border mt-2">
              <button className="btn btn-link link text-success shadow-none py-3" id="contract-history">
                <h5 className="mb-0"><i className="fas fa-angle-right mx-1"></i><Trans>History</Trans></h5>
              </button>
              <UncontrolledCollapse toggler="#contract-history">
                {value.contract_ending_requests?.length > 0 &&
                  <div className="ctr-ending-requests">
                    <p className="text-muted mx-3">- <Trans>Contract Ending Requests</Trans></p>
                    <Table size="sm" className="inv-table my-0">
                      <thead>
                        <tr>
                          <th className="border-0"><Trans>Details</Trans></th>
                          <th className="border-0"><Trans>Type</Trans></th>
                          <th className="border-0"><Trans>Status</Trans></th>
                          <th className="border-0"><Trans>Date</Trans></th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.contract_ending_requests?.map((i, index) => (
                          <tr key={index}>
                            <td>{i.details}</td>
                            <td>{i.auto_end ? t("Scheduled") : t("Not Scheduled")}</td>
                            <td>{i.active ? t("Pending") : i.approved ? t("Approved") : t("Rejected")}</td>
                            <td>{formatDate(i.updated_at)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                }
                {value.contract_renewals?.length > 0 &&
                  <div className="ctr-ending-requests">
                    <p className="text-muted mx-3">- <Trans>Contract Renewals</Trans></p>
                    <Table size="sm" className="inv-table my-0">
                      <thead>
                        <tr>
                          <th className="border-0"><Trans>Renewed Until</Trans></th>
                          <th className="border-0"><Trans>Note</Trans></th>
                          <th className="border-0"><Trans>Date</Trans></th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.contract_renewals?.map((i, index) => (
                          <tr key={index}>
                            <td>{i.extend_to}</td>
                            <td>{i.notes}</td>
                            <td>{formatDate(i.created_at)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                }
              </UncontrolledCollapse>
            </div>}

          <hr />

          <HistoryAndNotes
            item={value}
            contentType={'contract'}
            client={client}
            t={t}
          />

        </>
      }
    </Page>
  );
};

export default ContractEdit;
